export * from './related-invoices-list/related-invoices-list.component';
